import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function SugiAgentListManage() {
    let dispatch = useDispatch();
    let navigate = useNavigate();

    let MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);
    const [cancelListData, setCancelListData] = useState([]);
    const [combineData, setCombineData] = useState([]);
    const [combineList, setCombineList] = useState([]);
    const [cancelCombineData, setCancelCombineData] = useState([]);
    const [cancelCombineList, setCancelCombineList] = useState([]);
    const [reload, setReload] = useState(false);
    const [activeTab, setActiveTab] = useState("수기결제");
    const [listState, setListState] = useState(false);

    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    useEffect(() => {
        dispatch(change_Current_Location("수기결제승인내역"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "수기결제승인내역",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    // 날짜 선택
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload((e) => !e);
    };

    useEffect(() => {
        ListData();
        CancelListData();
    }, [reload]);

    const ListData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/sugi", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                console.log(tmp)
                setListData(tmp?.data ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
        }
    };

    const CancelListData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/sugi/cancel/list",
                {
                    withCredentials: true,
                }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                console.log(tmp)
                setCancelListData(tmp?.data ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const onDeleteData = async (id, mid) => {
        if (window.confirm("수기결제 승인요청을 취소하시겠습니까?") !== true) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/delete",
                { id: id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };
    const onCancelDeleteData = async (id, mid) => {
        if (window.confirm("수기결제 승인요청을 취소하시겠습니까?") !== true) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/cancel/delete",
                { id: id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };
    const tableHeaderData = [
        { no: 2, text: "시간", width: "80px", textAlign: "center" },
        { no: 3, text: "상태", width: "100px", textAlign: "center" },
        { no: 4, text: "가맹점", width: "150px", textAlign: "center" },
        { no: 5, text: "금액", width: "100px", textAlign: "center" },
        { no: 5, text: "승인번호", width: "100px", textAlign: "center" },
        { no: 5, text: "비고", width: "150px", textAlign: "center" },
        { no: 5, text: "삭제", width: "100px", textAlign: "center" },
    ];

    const tableHeaderData1 = [
        { no: 2, text: "시간", width: "80px", textAlign: "center" },
        { no: 3, text: "상태", width: "100px", textAlign: "center" },
        { no: 4, text: "가맹점", width: "150px", textAlign: "center" },
        { no: 5, text: "금액", width: "100px", textAlign: "center" },
        { no: 5, text: "승인번호", width: "100px", textAlign: "center" },
        { no: 5, text: "비고", width: "150px", textAlign: "center" },
        { no: 5, text: "삭제", width: "100px", textAlign: "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            // 전체 리스트를 combineList로도 세팅
            setCombineList(listData);

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i];
                let rowData = [
                    {
                        no: 2,
                        text: getDisplayTime(data.reg_date),
                        width: "80px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: data.status,
                        width: "100px",
                        textAlign: "center",
                    },
                    {
                        no: 4,
                        text: data.co_nm,
                        width: "150px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: changeNum(data.req_amount),
                        width: "100px",
                        textAlign: "right",
                    },
                    {
                        no: 5,
                        text: data.approval_id,
                        width: "100px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: data.desc,
                        width: "150px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                {
                                    data.status == "WAIT"
                                        ?
                                        <a
                                            className="delete flex items-center text-danger pointer"
                                            onClick={() => onDeleteData(data.id)}
                                        >
                                            <SquareX width={15} height={15} /> 취소
                                        </a>
                                        :
                                        ""
                                }
                            </div>
                        ),
                        width: "100px",
                        textAlign: "center",
                    }
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
            setListState((e) => !e);
            setCombineData(tableBodyData);
        }
    }, [listData]);


    useEffect(() => {
        let tableBodyData = [];
        if (cancelListData) {
            // 전체 리스트를 combineList로도 세팅
            setCancelCombineList(cancelListData);

            for (let i = 0; i < cancelListData.length; i++) {
                let data = cancelListData[i];
                let rowData = [
                    {
                        no: 2,
                        text: getDisplayTime(data.created_at),
                        width: "80px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: data.status,
                        width: "100px",
                        textAlign: "center",
                    },
                    {
                        no: 4,
                        text: data.co_nm,
                        width: "150px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: changeNum(data.amt),
                        width: "100px",
                        textAlign: "right",
                    },
                    {
                        no: 5,
                        text: data.approval_id,
                        width: "100px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: data.desc,
                        width: "150px",
                        textAlign: "center",
                    },
                    {
                        no: 5,
                        text: (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                {
                                    data.status == "WAIT"
                                        ?
                                        <a
                                            className="delete flex items-center text-danger pointer"
                                            onClick={() => onCancelDeleteData(data.id)}
                                        >
                                            <SquareX width={15} height={15} /> 취소
                                        </a>
                                        :
                                        ""
                                }
                            </div>
                        ),
                        width: "100px",
                        textAlign: "center",
                    }
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
            setListState((e) => !e);
            setCancelCombineData(tableBodyData);
        }
    }, [cancelListData]);

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    const tabList = ["수기결제", "수기결제취소"];

    // 경과 시간 표시
    const getDisplayTime = (regDate) => {
        const now = new Date();
        const dateObj = new Date(regDate);
        const kstDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000);
        const diffMs = now - kstDate;

        const diffMinutes = Math.floor(diffMs / 1000 / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMinutes < 60) return `${diffMinutes}분`;
        if (diffHours < 24) return `${diffHours}시간`;
        return `${diffDays}일`;
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
            >
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                        borderBottom: "1px solid #E5E5E5",
                        backgroundColor: "#fff",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom:
                                        activeTab === tab
                                            ? "3px solid #3182F6"
                                            : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                {activeTab === "수기결제" ? (
                    <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                        <div style={{ width: "100%", maxWidth: "900px" }}>
                            <List
                                tableHeaderData={tableHeaderData}
                                tableBodyData={combineList ?? []}
                                filter_tableBodyData={combineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                listType={true}
                                listState={listState}
                                nonePage={false}
                            />
                        </div>
                    </div>
                ) : (
                    <div style={{ width: "100%", maxWidth: "900px" }}>
                        <List
                            tableHeaderData={tableHeaderData1}
                            tableBodyData={cancelCombineList ?? []}
                            filter_tableBodyData={cancelCombineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            nonePage={false}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default SugiAgentListManage